module.exports = __webpack_public_path__ + "img/BG.ee554dc8.jpg";